<template>
    <c-dialog ref="dialog" title="授信还款单详情" mode="slide" width="85vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.record_no" class="m-detail-tag flex-center-cross">
                <label>{{detailData.record_no}}</label>
                <c-state async tag dict="AUDIT_STATE" :value="detailData.state"></c-state>
            </div>
        </template>

        <module>
            <module-col size="310">
                <c-detail class="m-detail-form">
                    <c-detail-item label="还款客户">
                        <strong>{{detailData.customer_name}}</strong>
                    </c-detail-item>
                    <c-detail-item label="还款单号">
                        {{detailData.record_no}}
                    </c-detail-item>
                    <c-detail-item label="审核状态">
                        <c-state async tag dict="AUDIT_STATE" :value="detailData.state"></c-state>
                    </c-detail-item>
                    <c-detail-item label="单据数量">
                        {{detailData.order_count||0}}
                    </c-detail-item>
                    <c-detail-item label="还款金额">
                        <strong style="color: red">￥{{detailData.repayment_amount||0}}</strong>
                    </c-detail-item>
                    <c-detail-item label="备注">
                        {{detailData.remark||'-'}}
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{detailData.create_user_realname}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date}}
                    </c-detail-item>
                    <c-detail-item label="审核人">
                        {{detailData.audit_user_realname||'-'}}
                    </c-detail-item>
                    <c-detail-item label="审核时间">
                        {{detailData.audit_date||'-'}}
                    </c-detail-item>
                    <c-detail-item label="审核备注">
                        {{detailData.audit_remark||'-'}}
                    </c-detail-item>
                    <c-detail-item label="还款凭证">
                        <template #default="{data}">
                            <c-file v-if="detailData.voucher_img_url" :src="detailData.voucher_img_url"></c-file>
                            <span v-else>-</span>
                        </template>
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <!--核销商品明细-->
                <module-tab name="授信支付详情" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="billList" border :paging="false">
                            <c-table-column
                                    name="order_no"
                                    label="订单号"
                                    width="130"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="商品信息"
                                    width="280"
                            >
                                <template #default="{data}">
                                    <c-state v-if="data.level_type" tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                                    <span>{{data.product_name}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    name="produce_code"
                                    label="背贴码"
                                    width="130"
                            >
                            </c-table-column>

                            <c-table-column
                                    name="imei"
                                    label="IMEI码"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column label="售卖类型" width="100">
                                <template #default="{data}">
                                    <c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="交易金额" width="100">
                                <template #default="{data}">
                                    <span style="color: green">￥{{data.sale_price||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="退款金额" width="100">
                                <template #default="{data}">
                                    <span style="color: red">￥{{data.after_sale_amount||0}}</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="当前欠款" width="100">
                                <template #default="{data}">
                                    <span style="color: green;" v-if="data.credit_bill_state != 3">￥{{data.debt_amount||0}}</span>
                                    <span v-else>-</span>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    name="create_user_realname"
                                    label="下单人"
                                    width="130"
                            >
                            </c-table-column>
                            <c-table-column
                                    name="create_date"
                                    label="下单时间"
                                    width="130"
                            >
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
            <template #button v-if="auth('b_credit_repayment_audit') && detailData.state == 1">
                <c-button color="main" size="dialog" @click="$refs.auditDialog.open()">还款审核</c-button>
            </template>

            <!--还款单审核弹窗-->
            <c-dialog ref="auditDialog" title="还款单审核" width="500" @resolve="handleAudit">
                <c-form ref="auditForm" unit-width="100%">
                    <c-form-item label="审核结果" required>
                        <c-radio-group name="state" :options="stateDic" v-model="state"></c-radio-group>
                    </c-form-item>
                    <c-form-item label="还款凭证" v-if="state == 2" required>
                        <c-upload-file name="voucher_img_url" type="image"></c-upload-file>
                    </c-form-item>
                    <c-form-item label="审核备注" :required="state == 3?true:false">
                        <c-input type="textarea" name="audit_remark" maxlength="500" placeholder="请输入信息信息"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'creditRepaymentDetail',

    components: {
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            //审批结果
            stateDic: [
                {name: '审批通过',value: 2,color: 'blue'},
                {name: '审批驳回',value: 3,color: 'red'},
            ],
            state:2,         //审批状态
        }
    },

    computed: {
    },

    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },
        /**
         * 加载详情
         */
        detail(){
            this.request({
                url: '/order/credit/repayment/detail',
                data: {
                    repayment_id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.repayment_order_detail;
                    this.$refs.billList.setData(data.bill_list);
                }
            });
        },
        open() {
            this.detail();
            this.$refs.dialog.open();
        },
        /******还款单审核*******/
        handleAudit(stop, next) {
            stop();
            this.$refs.auditForm.submit({
                url: '/order/credit/repayment/audit',
                rule: {
                    state: '请选择审核结果',
                    voucher_img_url: [{
                        type: 'empty',
                        message: '请选择还款凭证',
                        skip: () => {
                            return this.state == 3;
                        }
                    }],
                    audit_remark: [{
                        type: 'empty',
                        message: '请输入审核备注信息',
                        skip: () => {
                            return this.state == 3;
                        }
                    }]
                },
                dataFormatter: (data) => {
                    data.repayment_id = this.id
                    return data;
                },
                success: () => {
                    next();
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.$refs.dialog.close();
                    //回调函数
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>